<template>
  <div>
    <vs-card>
      <form role="form" @submit.stop.prevent="buscar">
        <div :class="`vx-row mb-0 ${filtroAvancado ? 'sm:mb-0' : 'sm:mb-4'}`">
          <!-- Código -->
          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Código</span>
            <vs-input
              class="w-full"
              name="codigo"
              id="codigo"
              v-model="formFiltro.idProspect"
            />
          </div>

          <!-- Nome Beneficiário -->
          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Nome Beneficiário</span>
            <AutoComplete
              customClass="w-full"
              name="Nome"
              id="Nome"
              v-model="formFiltro.nomeAssociado"
              :configAutoComplete="{ model: 'Associados', field: 'nome' }"
            />
          </div>

          <!-- CPF/CNPJ -->
          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>CPF/CNPJ</span>
            <AutoComplete
              customClass="w-full"
              name="Cpf Cnpj"
              id="Cpf Cnpj"
              v-model="formFiltro.cpfCnpj"
              :configAutoComplete="{ model: 'Associados', field: 'cpfcnpj' }"
              :minimumCharacters="3"
            />
          </div>

          <!-- Placa -->
          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>Placa</span>
            <AutoComplete
              customClass="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :configAutoComplete="{ model: 'Veiculos', field: 'placa' }"
              :minimumCharacters="3"
            />
          </div>

          <!-- Chassi -->
          <div :class="`vx-col sm:w-1/6 mt-3 w-full`">
            <span>Chassi</span>
            <AutoComplete
              customClass="w-full"
              name="Chassi"
              id="Chassi"
              v-model="formFiltro.chassi"
              :configAutoComplete="{ model: 'Veiculos', field: 'chassi' }"
            />
          </div>

          <!-- Dia de Vencimento           -->
          <div class="vx-col sm:w-1/6 mt-3 w-full">
            <span>Dia de Vencimento</span>
            <vs-input
              class="w-full"
              name="Dia de Vencimento"
              id="Dia de Vencimento"
              v-model="formFiltro.diaVencimento"
            />
          </div>
        </div>

        <div v-if="filtroAvancado == true" class="vx-row">
          <!-- Consultor -->
          <div class="vx-col sm:w-1/5 mt-3 w-full">
            <span>Consultor</span>
            <v-select
              :options="consultores"
              name="Consultor"
              id="Consultor"
              multiple
              v-model="formFiltro.consultor"
            ></v-select>
          </div>

          <!-- Regional -->
          <div class="vx-col sm:w-1/5 mt-3 w-full">
            <span>Regional</span>
            <v-select
              :options="regionais"
              name="Regional"
              id="Regional"
              multiple
              v-model="formFiltro.regional"
            ></v-select>
          </div>

          <!-- Status -->
          <div class="vx-col sm:w-1/5 mt-3 w-full">
            <span>Status</span>
            <v-select
              :options="status"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
            ></v-select>
          </div>

          <!-- Estado -->
          <div class="vx-col sm:w-1/5 mt-3 w-full">
            <span>Estado</span>
            <v-select
              :options="estados"
              name="Estado"
              id="Estado"
              v-model="estado"
              @selected="buscaDadosSelectsCidades"
            ></v-select>
          </div>

          <!-- Cidade -->
          <div class="vx-col sm:w-1/5 mt-3 w-full">
            <span>Cidade</span>
            <v-select
              :options="cidades"
              name="Cidade"
              id="Cidade"
              multiple
              v-model="formFiltro.cidade"
            ></v-select>
          </div>
        </div>

        <div v-if="filtroAvancado == true" class="vx-row mb-0 sm:mb-4">
          <!-- Particpa Rateio -->
          <div class="vx-col sm:w-1/4 mt-3 w-full">
            <span>Participa Rateio</span>
            <v-select
              :options="listaSimNao"
              name="Boleto Físico"
              id="Boleto Físico"
              v-model="formFiltro.participaRateio"
            ></v-select>
          </div>

          <!-- Gera Cobrança -->
          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Gera Cobrança</span>
            <v-select
              :options="listaSimNao"
              name="Boleto Físico"
              id="Boleto Físico"
              v-model="formFiltro.geraCobranca"
            ></v-select>
          </div>

          <!-- Boleto Físico -->
          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Boleto Físico</span>
            <v-select
              :options="listaSimNao"
              name="Boleto Físico"
              id="Boleto Físico"
              v-model="formFiltro.boletoFisico"
            ></v-select>
          </div>

          <!-- Produto -->
          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Produto</span>
            <vs-input
              class="w-full"
              name="Produto"
              id="Produto"
              v-model="formFiltro.produto"
            />
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row class="flex justify-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            v-if="b2c == false"
            @click="buscaFiltrosAvancados()"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            v-if="b2c == false"
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import jwt from 'jsonwebtoken';
import AutoComplete from '../../components/autocomplete/AutoComplete.vue';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      this.buscaDadosSelectsCidades(
        'domMunicipio',
        'cidades',
        'nomeCidade',
        'idCidade',
      );
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      regionalDefault: [],
      regionaisUsuario: [],
      cidades: [],
      grupos: [],
      regionais: [],
      usuarios_regionais: [],
      consultores: [],
      status: [],
      languages: lang,
      filtroAvancado: false,
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tiposDatas: ['Data Cadastro', 'Data Vistoria'],
      listaSimNao: ['Sim', 'Não'],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idEmpresa: null,
        cpfCnpj: '',
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        tipoData: 'Data Cadastro',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProspect: null,
        tipoCotacao: null,
        diaVencimento: null,
        placa: null,
        chassi: null,
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        cpfCnpj: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        tipoData: 'Data Cadastro',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProspect: null,
        tipoCotacao: null,
        diaVencimento: null,
        placa: null,
        chassi: null,
      };
      this.buscar();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
    buscaDadosRegionais() {
      service
        .getAll('Usuario', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.idUsuario == this.id_usuario) {
              if (element.usuarios_regionais.length > 0) {
                this.usuarios_regionais = element.usuarios_regionais;

                this.usuarios_regionais.forEach((elementSel) => {
                  this.regionaisUsuario.push({
                    id: elementSel.id_regional,
                    label: elementSel.nome,
                  });
                  this.idRegionais = this.regionais.map((item) => item.id);
                });

                this.regionais = this.regionaisUsuario.concat(
                  this.regionalDefault,
                );
              } else {
                var usuarios_regionais = element.Usuarios_Regional;
                this.regionais.push({
                  id: usuarios_regionais.idRegional,
                  label: usuarios_regionais.nome,
                });
                this.idRegionais = this.regionais.map((item) => item.id);
              }
            }
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosGrupos() {
      service
        .getAll('Grupo', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.grupos.push({
              id: element.idGrupo,
              label: element.nomeGrupo,
            });
          });
        });
    },
    buscaDadosConsultor() {
      service
        .getAll('Usuario', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.consultores.push({
              id: element.idUsuario,
              label: element.nome,
            });
          });
        });
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    buscaDadosAtivosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .post(model, `list`, {
          idEmpresa: this.idEmpresa,
          notDeleted: true,
          tipoStatus: 'ASSOCIADOS',
        })
        .then((res) => {
          this[array].push({ label: 'Selecionar Todos', id: 0 });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    async buscaFiltrosAvancados() {
      if (!this.filtroAvancado) {
        this.filtroAvancado = true;
        if (this.grupos.length == 0) {
          this.buscaDadosGrupos();

          this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');

          this.buscaDadosAtivosSelectsPorEmpresa(
            'status',
            'status',
            'nomeStatus',
            'idStatus',
          );

          this.buscaDadosFiltros();
        }
      } else this.filtroAvancado = false;
    },
    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service
          .post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
          .then(({ data }) => {
            data.consultores.forEach((element) => {
              this.consultores.push({
                id: element.id_usuario,
                label: element.nome,
              });
            });

            data.regionais.forEach((element) => {
              this.regionais.push({
                id: element.idRegional,
                label: element.nome,
              });
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    buscar() {
      this.$emit('filtro', this.formFiltro);
    },
  },
  mounted() {
    this.getDecoded();
  },
  components: {
    'v-select': vSelect,
    AutoComplete,
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
